import isNil from 'lodash/isNil';
import { useRangeAnalysisQuery } from '../../hooks/useRangeAnalysisQuery';
import { type AnalysisSubject } from 'venn-utils';

export function useRangeAnalysis(subject?: AnalysisSubject) {
  const { rangeAnalysis: rangeAnalysisResult, analysisRequest, isFetching } = useRangeAnalysisQuery(subject);

  // Force a loading state while fetching by hiding the previous range analysis result.
  const rangeAnalysis = isFetching ? undefined : rangeAnalysisResult;
  const primaryIndex = analysisRequest?.subjects?.findIndex((s) => s.comparisonType === 'PRIMARY');
  const primaryAnalysis = !isNil(primaryIndex) ? rangeAnalysis?.rangeAnalyses[primaryIndex] : undefined;

  const primaryRangeAnalysis = !isNil(primaryAnalysis)
    ? {
        start: primaryAnalysis.historicalStart ?? primaryAnalysis.start,
        end: primaryAnalysis.historicalEnd ?? primaryAnalysis.end,
        frequency: primaryAnalysis.frequency,
      }
    : undefined;

  return {
    rangeAnalysis,
    primaryAnalysis,
    primaryRangeAnalysis,
  };
}
